import carousel from './carousel';

const collectionSwipers = document.querySelectorAll('.CollectionCarousel-swiper');
const collectionSwipersAlt = document.querySelectorAll(
  '.CollectionCarousel-swiper--collections-page'
);

const mobileView = 1;
const tabletView = 2;
const laptopView = 4;

function initSwiper(slides, mobileSlidesPerView, tabletSlidesPerView, laptopSlidesPerView) {
  slides.forEach((collection) => {
    carousel(
      collection,
      {
        loop: false,
        centeredSlides: false,
        slidesPerView: mobileSlidesPerView,
        slidesPerGroup: mobileSlidesPerView,
        spaceBetween: 24,
        slidesOffsetBefore: 0,
        threshold: 1,
        breakpoints: {
          768: {
            slidesPerView: tabletSlidesPerView,
            slidesPerGroup: tabletSlidesPerView,
          },
          1024: {
            slidesPerView: laptopSlidesPerView,
            slidesPerGroup: laptopSlidesPerView,
          },
        },
      },
      true
    );
  });
}

initSwiper(collectionSwipers, mobileView, tabletView, laptopView);
initSwiper(collectionSwipersAlt, mobileView + 1, tabletView + 1, laptopView + 1);
